var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    Är ett gavelskydd som skyddar gaveln vid påkörning. Påkörningsskydd är ett krav för att pallstället ska vara godkänt om du har trucktrafik i området.\n  ")])])
}]

export { render, staticRenderFns }